import ThreadEditModal from '@/thread/modals/ThreadEditModal'
import { useDisclosure } from '@chakra-ui/react'
import { ThreadFragment } from '@gql'
import React, { useCallback, useState } from 'react'
import { useThreadSearchItems } from '../hooks/useThreadSearchItems'
import SearchButton, { SearchButtonProps } from './SearchButton'

interface Props extends Omit<SearchButtonProps, 'items' | 'onCreate'> {
  threads: ThreadFragment[]
  excludeIds?: string[]
  createCircleId?: string
}

export default function ThreadSearchButton({
  threads,
  excludeIds,
  createCircleId,
  onSelect,
  ...props
}: Props) {
  const items = useThreadSearchItems(threads, excludeIds)
  const createModal = useDisclosure()
  const [defaultTitle, setDefaultTitle] = useState('')

  // Instead of creating the thread directly, open ThreadEditModal so the
  // type (Tactical/Governance) can never be skipped: it's the only entry
  // point that persists a thread, so the NOT NULL invariant always holds.
  const handleCreate = useCallback(
    async (title: string) => {
      setDefaultTitle(title)
      createModal.onOpen()
    },
    [createModal]
  )

  const handleThreadCreated = useCallback(
    (id: string) => {
      onSelect(id)
    },
    [onSelect]
  )

  return (
    <>
      <SearchButton
        {...props}
        items={items}
        onSelect={onSelect}
        onCreate={createCircleId !== undefined ? handleCreate : undefined}
      />

      {createModal.isOpen && createCircleId && (
        <ThreadEditModal
          isOpen
          defaults={{ title: defaultTitle, circleId: createCircleId }}
          onCreate={handleThreadCreated}
          onClose={createModal.onClose}
        />
      )}
    </>
  )
}
